import { bearerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const oura = defineConnector({
  identifier: "oura",
  name: "Oura",
  tagLine: "Health and sleep tracking",
  logo,
  protocol: "http",
  tags: ["data"],
  defaultUrlPattern: () => "https://api\\.ouraring\\.com/.*",
  auth: (app) => bearerAuth(app.secret.accessToken),
  steps: [
    {
      title: "Get your access token",
      items: [
        {
          kind: "markdown",
          content:
            "In the [Oura developer portal](https://cloud.ouraring.com/), create a personal access token.",
        },
      ],
    },
    {
      title: "Enter your access token",
      items: [
        {
          kind: "input",
          label: "Access token",
          required: true,
          target: { kind: "secrets", field: "accessToken" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://api.ouraring.com/v2/usercollection/personal_info",
  },
});
